export default class Action {
    constructor(id, actionType, canvas) {
        this.actionType = actionType;
        this.id = id;
        this.canvas = canvas;
        this.json = canvas.toJSON(['id','svgStrokeArray','svgColorArray', 'feathering', 'isShadow', 'isOutline', 'isGradient', 'borderColor', 'cornerColor', 'cornerStyle', 'transparentCorners', 'originalSrc', 'actualDim', 'objectCaching']);
    }
}
